import { ROOT_DOMAIN, TALKIE_PRODUCTION_DOMAINS } from '../config/host';
import { isDev, isProd, isTalkie } from './env';

// 为什么做成配置化
// 因为从 request 获取 root domain 并非一个简单的事情，需要考虑多种情况
// 1. 环境区别，容器环境有 nginx 需要获取 x-forwarded-host, 本地则可能是 host
// 2. 浏览器区别，不同浏览器的请求可能带的 header 不一样
// 3. 请求方法的区别，api 请求和 middleware 请求时候 request 的处理也不一样
// 总的来说做成配置化是最不容易出错的选择

/**
 * 从 host 字符串中匹配已知的 talkie 生产域名
 * 例如: 'www.talkie-ai.com' -> 'talkie-ai.com'
 *       'www.talkie-ai.in'  -> 'talkie-ai.in'
 */
export function extractTalkieDomain(host: string): string | null {
  for (const domain of TALKIE_PRODUCTION_DOMAINS) {
    if (host.includes(domain)) {
      return domain;
    }
  }
  return null;
}

/**
 * 获取当前请求的根域名，用于设置 Cookie 的 domain 属性
 * @param host 可选，请求的 host（服务端传入 req.headers.host 或 request.headers.get('host')）
 */
export function getRootDomain(host?: string): string {
  try {
    if (isProd) {
      if (isTalkie) {
        // 服务端优先使用传入的 host，浏览器端 fallback 到 window.location.host
        const currentHost =
          host ?? (typeof window !== 'undefined' ? window.location.host : undefined);
        if (currentHost) {
          const domain = extractTalkieDomain(currentHost);
          if (domain) return `.${domain}`;
        }
      }
      return `.${ROOT_DOMAIN.production}`;
    }
    if (isDev) {
      return `${ROOT_DOMAIN.development}`;
    }
    return `.${ROOT_DOMAIN.test}`;
  } catch (e) {
    return `.${ROOT_DOMAIN.production}`;
  }
}
